import { ChangeEvent, useCallback } from 'react';

import { ShareOutlined } from '@mui/icons-material';

import Button from '@/components/Buttons/Button';
import ShareDialog from '@/components/ShareDialog';
import Typography from '@/components/Typography';
import useShareButton from '@/pages/Markets/MarketsComponents/Share/ShareButton/useShareButton';

const SharePromptButton = ({ prompt }: { prompt: string }) => {
  const shareUrl = `${window.location.origin}/markets?prompt=${encodeURIComponent(prompt)}`;

  const {
    modalOpen,
    setModalOpen,
    content,
    setContent,
    recipient,
    handleChangeRecipient,
    handleCopyToClipboard,
    sendEmail,
    emailError
  } = useShareButton('', shareUrl);

  const handleClose = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  const handleContentChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setContent(e.target.value);
    },
    [setContent]
  );

  const handleClick = useCallback(() => {
    setModalOpen(true);
  }, [setModalOpen]);

  return (
    <>
      <Button
        sx={{
          backgroundColor: 'var(--GX-action-bar-button-tile, rgba(248, 248, 248, 0.20))',
          height: '34px',
          width: '117px'
        }}
        onClick={handleClick}
      >
        <ShareOutlined />
        <Typography
          sx={{
            fontSize: '14px',
            whiteSpace: 'nowrap'
          }}
        >
          Share prompt
        </Typography>
      </Button>
      <ShareDialog
        content={content}
        emailError={emailError}
        enableSendEmail={false}
        handleChangeRecipient={handleChangeRecipient}
        header='Share GX Go Assistant prompt'
        open={modalOpen}
        recipient={recipient}
        shareUrl={shareUrl}
        onClose={handleClose}
        onContentChange={handleContentChange}
        onCopyClick={handleCopyToClipboard}
        onSendEmail={sendEmail}
      />
    </>
  );
};

export default SharePromptButton;
